import { Observable } from "rxjs";
import { Tenant } from "../domain/models/tenant";
import { TenantConfiguration } from "../domain/models";
import { Injectable } from "@angular/core";

@Injectable({providedIn: 'root'})
export abstract class TenantRepository {
    abstract getTenantById(request: string): Observable<Tenant>;
    abstract getTenantConfiguration(): Observable<TenantConfiguration[]>;
}
